/* Foxhills — Coastal Collection page interactions.
   Shop-the-look bottom sheets + carousel arrows. No dependencies. */
(function () {
  'use strict';

  // Looks whose products aren't published yet render empty sheets; hide their
  // pill and disable the trigger so a tile never opens an empty panel.
  function markEmptyLooks() {
    document.querySelectorAll('.coastal-look').forEach(function (tile) {
      var hasItems = !!tile.querySelector('.coastal-look__item');
      tile.classList.toggle('coastal-look--empty', !hasItems);
    });
  }
  if (document.readyState !== 'loading') markEmptyLooks();
  else document.addEventListener('DOMContentLoaded', markEmptyLooks);

  // Shop-the-look: the whole image (or pill) opens a LARGE modal — look image
  // beside a roomy product list — like the reference's shoppable menu.
  var MODAL_ID = 'CoastalLookModal';

  function openLookModal(tile) {
    if (document.getElementById(MODAL_ID)) return;
    var list = tile.querySelector('.coastal-look__products');
    if (!list) return;
    var img = tile.querySelector('.coastal-look__img');
    var src = img ? (img.currentSrc || img.src) : '';
    var el = document.createElement('div');
    el.id = MODAL_ID;
    el.className = 'coastal-lookm';
    el.innerHTML =
      '<div class="coastal-lookm__overlay" data-lookm-close></div>' +
      '<div class="coastal-lookm__box" role="dialog" aria-label="Shop the look">' +
        '<button type="button" class="coastal-lookm__close" data-lookm-close aria-label="Close">&times;</button>' +
        (src ? '<div class="coastal-lookm__media"><img class="coastal-lookm__img" src="' + src + '" alt=""></div>' : '') +
        '<div class="coastal-lookm__body">' +
          '<div class="coastal-lookm__head">Shop the look</div>' +
          '<div class="coastal-lookm__list"></div>' +
        '</div>' +
      '</div>';
    document.body.appendChild(el);
    // move the tile's server-rendered product list into the modal (returned on close)
    list._coastalHome = tile;
    list.classList.add('coastal-look__products--inmodal');
    el.querySelector('.coastal-lookm__list').appendChild(list);
    document.documentElement.classList.add('coastal-lookm-open');
    requestAnimationFrame(function () { el.classList.add('is-open'); });
  }

  function closeLookModal() {
    var el = document.getElementById(MODAL_ID);
    if (!el) return;
    var list = el.querySelector('.coastal-look__products');
    if (list && list._coastalHome) {
      list.classList.remove('coastal-look__products--inmodal');
      list._coastalHome.appendChild(list);
    }
    document.documentElement.classList.remove('coastal-lookm-open');
    el.classList.remove('is-open');
    setTimeout(function () { if (el.parentNode) el.remove(); }, 220);
  }
  window.coastalCloseLookModal = closeLookModal;

  document.addEventListener('click', function (ev) {
    if (ev.target.closest && ev.target.closest('[data-lookm-close]')) { closeLookModal(); return; }
    var toggle = ev.target.closest && ev.target.closest('[data-look-toggle], .coastal-look__media');
    if (!toggle) return;
    var tile = toggle.closest('.coastal-look');
    if (!tile || tile.classList.contains('coastal-look--empty')) return;
    if (toggle.matches && toggle.matches('.coastal-look__close')) return;
    openLookModal(tile);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeLookModal();
  });

  // Carousel arrows: scroll by one viewport
  document.addEventListener('click', function (ev) {
    var prev = ev.target.closest && ev.target.closest('[data-coastal-prev]');
    var next = ev.target.closest && ev.target.closest('[data-coastal-next]');
    if (!prev && !next) return;
    var root = (prev || next).closest('.coastal-carousel');
    var track = root && root.querySelector('[data-coastal-track]');
    if (!track) return;
    var delta = track.clientWidth * 0.9 * (next ? 1 : -1);
    track.scrollBy({ left: delta, behavior: 'smooth' });
  });
})();

/* Carousel progress bar: reflect scroll position */
(function () {
  'use strict';
  function updateProgress(track) {
    var root = track.closest('.coastal-carousel');
    var fill = root && root.querySelector('[data-coastal-progress]');
    if (!fill) return;
    var max = track.scrollWidth - track.clientWidth;
    var visible = max <= 0 ? 1 : track.clientWidth / track.scrollWidth;
    var pos = max <= 0 ? 0 : track.scrollLeft / max;
    fill.style.width = (visible * 100) + '%';
    fill.style.transform = 'translateX(' + (pos * (1 / visible - 1) * 100) + '%)';
  }
  function init() {
    document.querySelectorAll('[data-coastal-track]').forEach(function (t) {
      updateProgress(t);
      t.addEventListener('scroll', function () { updateProgress(t); }, { passive: true });
    });
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();


/* Quick add from a look sheet, Mejuri-style. Single-variant products add
   directly; multi-variant "Add" reveals an inline variant chooser first.
   Adds via /cart/add.js then opens the theme cart drawer (waiting for the
   page-speed-deferred jQuery if needed). */
(function () {
  'use strict';

  function openDrawer(tries) {
    tries = tries || 0;
    if (window.jQuery && window.theme && window.theme.cart) {
      window.jQuery('body').trigger('added.ajaxProduct');
    } else if (tries < 50) {
      setTimeout(function () { openDrawer(tries + 1); }, 100);
    }
  }

  document.addEventListener('click', function (ev) {
    // Multi-variant: toggle the inline chooser under the row
    var chooserBtn = ev.target.closest && ev.target.closest('[data-look-variants]');
    if (chooserBtn) {
      ev.preventDefault();
      var row = chooserBtn.closest('.coastal-look__item');
      var panel = row && row.nextElementSibling;
      if (panel && panel.classList.contains('coastal-look__variants')) {
        var show = panel.hasAttribute('hidden');
        var sheet = row.closest('.coastal-look__products');
        if (sheet) sheet.querySelectorAll('.coastal-look__variants').forEach(function (p) { p.setAttribute('hidden', ''); });
        if (show) panel.removeAttribute('hidden');
      }
      return;
    }

    var btn = ev.target.closest && ev.target.closest('[data-look-add]');
    if (!btn || btn.disabled) return;
    ev.preventDefault();
    btn.disabled = true;
    var label = btn.textContent;
    btn.textContent = '...';
    fetch('/cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: parseInt(btn.getAttribute('data-look-add'), 10), quantity: 1 })
    }).then(function (r) {
      if (!r.ok) throw new Error('add failed');
      btn.textContent = 'Added';
      var panel = btn.closest('.coastal-look__variants');
      if (panel) setTimeout(function () { panel.setAttribute('hidden', ''); }, 500);
      if (window.coastalCloseLookModal) setTimeout(window.coastalCloseLookModal, 450);
      openDrawer();
      setTimeout(function () { btn.textContent = label; btn.disabled = false; }, 1600);
    }).catch(function () {
      btn.textContent = label; btn.disabled = false;
    });
  });
})();
